module.exports = __webpack_public_path__ + "static/dpcgclogo-d03b6b8eb30e1d1cf99d8f576a2c39d4.svg";